export default __webpack_public_path__ + "static/media/token_33T.d541d6e5.svg";